import React from "react";
import { ArrowDown } from "lucide-react";
import styles from "./SortToggle.module.scss";

interface Props {
  dir: "asc" | "desc";
  onToggle: () => void;
}

export const SortToggle: React.FC<Props> = ({ dir, onToggle }) => (
  <button
    className={`${styles.sortToggle} ${dir === "asc" ? styles.asc : ""}`}
    onClick={onToggle}
    title={`Sort ${dir === "asc" ? "descending" : "ascending"}`}
  >
    <ArrowDown size={16} />
  </button>
);
